const responsive = {
  xs: 480,
  s: 768,
  m: 1024,
  l: 1200,
  xl: 1600,

  extraSmallHeight: 750,
  smallHeight: 1000,
};

export default responsive;
